import React, { useState } from "react";
import { useClasseContext } from "../context/ClasseContext";
import ChangePassword from "../components/VueMyAccount/ChangePassword";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { User } from 'lucide-react';
function MyAccount() {
    const {user} = useUser();
    const { nomProf } = useClasseContext();

    const [changePasswordView, setChangePassWordView] = useState(false)
    const navigate = useNavigate();

 

const handleChangePassWord = () => {
  setChangePassWordView(!changePasswordView);
}
const handleBack = () => {
  navigate('/home')
}

  // Return null or a loading indicator as the navigation will be handled by the useEffect hook
  return (
  <div className=" w-full h-fit flex justify-center">
   
  <div className=" flex flex-col gap-5 text-base  bg-white shadow-sm shadow-slate-200  w-1/2 p-5 rounded-3xl">
  <p className="italic underline text-blue-800 cursor-pointer hover:font-bold" onClick={handleBack}> ⬅ Retour à l'accueil </p> 
 <div className="flex w-full justify-center"> <User className="w-10 h-10 text-blue-600" />  </div> 
<p className="text-center text-3xl font-bold"> Mes informations </p>
  <p className=" text-xl"> Nom : {nomProf && nomProf.split(' ')[0]} </p>

<p className=" text-xl"> Prénom : {nomProf && nomProf.split(' ')[1]} </p>

<p className=" text-xl"> Identifiant :  {user.username} </p> 

<p className=" text-xl"> Discipline : Mathématiques </p>
        
      {!changePasswordView &&  <p className=" italic underline text-blue-800 cursor-pointer hover:font-bold" onClick={handleChangePassWord}> Changer mon mot de passe</p> }

      {changePasswordView && <ChangePassword />}
    </div>

    </div> 
  )
}

export default MyAccount;